import { Module, MutationTree, ActionTree, GetterTree } from 'vuex';
import dayjs from '@/utils/dayjs';

export class localStorageState {}
const Mutations: MutationTree<localStorageState> = {};
const Actions: ActionTree<localStorageState, any> = {
  saveToLocalStorage({ rootGetters }) {
    localStorage.setItem(
      'dpost-v1',
      JSON.stringify({
        auth: {
          sessionToken: rootGetters['auth/getSessionToken'](),
          clientInfo: rootGetters['auth/getClientInfo'](),
          centerInfo: rootGetters['auth/getCenterInfo'](),
          marketing: rootGetters['auth/getMarketing'](),
        },
        i18n: {
          locale: rootGetters['i18n/getLocale'](),
        },
      })
    );
  },
  //로컬스토리지에 데이터 없는 경우 초기화
  savePopupDataLocalStorage({ rootGetters }) {
    const popupOpenFrom = rootGetters['notice/getNoticeIsShowToday'];
    localStorage.setItem('popupOpenFrom', JSON.stringify(popupOpenFrom));
  },
  removeLocalStorage() {
    localStorage.removeItem('dpost-v1');
  },
};
const Getters: GetterTree<localStorageState, any> = {};

const module: Module<localStorageState, any> = {
  namespaced: true,
  state: new localStorageState(),
  mutations: Mutations,
  actions: Actions,
  getters: Getters,
};

export default module;
